angular
    .module("lodgeClaimACTG.controller", ['ui.mask', 'ngRoute'])
    .controller('lodgeClaimACTGController', ['$rootScope', '$scope', '$timeout', '$filter', '$window', 'popupService', 'lodgeClaimACTGWording', 'uploadFileWording', 'lodgeClaimACTGService', 'httpService', 'userService', 'userProfileService',

        function ($rootScope, $scope, $timeout, $filter, $window, popupService, lodgeClaimACTGWording, uploadFileWording, lodgeClaimACTGService, httpService, userService, userProfileService) {
            UploadFileExtension($scope, {
                // $form: document.querySelector('#fileupload'),
                submitText: 'Submit',
                fnSubmitFile: fnSubmitFile,
                fnFileUploadAdd: fnFileUploadAdd,
                fnFileUploadStop: fnFileUploadStop,
            }, uploadFileWording, $window, httpService);
            $scope.baseUploadPath = 'uploads';
            $scope.test;
            $scope.currentTabIndex = 0;
            $scope.pageForms = {};
            $scope.pageName = 'Claim Lodgement';
            $scope.formData = {
                notification: $scope.notification,
                uploadSession: $scope.generateUploadSession()
            }
            $scope.injuryNatureDropDown = [];
            $scope.injuryAreaDropDown = [];
            $scope.location = 'claim-lodgement';
            $scope.nextInvalid = '';
            $scope.isReadOnly = false;
            $scope.today = (new Date()).toLocaleDateString('en-GB');
            $scope.maxDoB = new Date();
            $scope.maxDoB.setFullYear($scope.maxDoB.getFullYear() - 13);
            $scope.maxDoB = $scope.maxDoB.toLocaleDateString('en-GB');
            //session init
            var initTooltip = function () {
                var titleToolTips = '';
                var titleEmployment = '';
                var titleInjuryDate = '';
                var titleInjuryDescription = '';
                var titleFirstSeekDate = '';
                var titleOtherMedicalProvider = '';

                titleOtherMedicalProvider = '<p>Other treatment providers might include physiotherapist, chiropractor, psychologist, etc.</p>';
                titleToolTips = '<p>E.g: Mr., Mrs., Ms., Dr., Professor, etc.</p>';
                titleFirstSeekDate = '<p>What was the first date you sought treatment for your symptoms?</p>';
                titleEmployment = '<p>You need to let us know about any other employment you have outside of the ACTPS.</p>';
                titleInjuryDescription = "<p>If you would like to submit any further information or documentation in support of your claim, for example photos or statements, you can attach these in the ATTACHMENTS section of this form</p>";
                titleInjuryDate = '<p>If this was a gradual onset injury, for example tendonitis of the elbow, please provide the date you first sought treatment.</p>';
                titleEmployerName = '<p>Selecting the wrong Directorate may cause delays processing your claim.</p>';
                $('[data-target="title"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleToolTips,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });

                $('[data-target="employment"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleEmployment,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });

                $('[data-target="injurydate"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleInjuryDate,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });

                $('[data-target="injuryDescription"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleInjuryDescription,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });

                $('[data-target="firstSeek"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleFirstSeekDate,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });
                $('[data-target="OtherMedicalProvider"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleOtherMedicalProvider,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });
                $('[data-target="employerName"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleEmployerName,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });
            }

            var initDatePicker = function () {
                $('#txt_EmployeeDateofbirth').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    yearRange: "1900:9999",
                    maxDate: "-13Y",
                    onSelect: function (dataText) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationEmployeeDetail.EmployeeDateofbirth = dataText;
                            $scope.$apply();
                        })
                    }
                });

                $('#txt_InjuryDate').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    yearRange: "1900:9999",
                    maxDate: '0y',
                    onSelect: function (dataText) {
                        $timeout(function () {
                            $('#txt_ReportedDate').datepicker('option', 'minDate', toDate(dataText));
                            $('#txt_FirstNoticeDate').datepicker('option', 'minDate', toDate(dataText));
                            $('#txt_DateStoppedWork').datepicker('option', 'minDate', toDate(dataText));
                            $('#txt_ReturnedToWorkDate').datepicker('option', 'minDate', toDate(dataText));
                            $('#txt_FirstSeekDate').datepicker('option', 'minDate', toDate(dataText));
                            $scope.notification.InjuryNotificationInjuryDetail.InjuryDate = dataText;
                            $scope.$apply();
                        })
                    }
                });

                $('#txt_ReportedDate').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    yearRange: "1900:9999",
                    maxDate: '0y',
                    onSelect: function (dataText) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationInjuryDetail.ReportedDate = dataText;
                            $scope.$apply();
                        })
                    }

                });

                $('#txt_DateStoppedWork').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    yearRange: "1900:9999",
                    maxDate: '0y',
                    onSelect: function (dataText) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationInjuryDetail.DateStoppedWork = dataText;
                            $scope.$apply();
                        })
                    }
                });

                $('#txt_ReturnedToWorkDate').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    yearRange: "1900:9999",
                    maxDate: '0y',
                    onSelect: function (dataText) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationInjuryDetail.ReturnedToWorkDate = dataText;
                            $scope.$apply();
                        })
                    }
                });

                $('#txt_FirstSeekDate').datepicker({
                    dateFormat: 'dd/mm/yy',
                    changeMonth: true,
                    changeYear: true,
                    showButtonPanel: true,
                    yearRange: "1900:9999",
                    maxDate: '0y',
                    onSelect: function (dataText) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationMedicalTreatment.FirstSeekDate = dataText;
                            $scope.$apply();
                        })
                    }
                });
            }

            var initTimePicker = function () {
                $('#txt_InjuryTime').timepicker({
                    timeFormat: 'HH:mm',
                    interval: 10,
                    dynamic: true,
                    dropdown: true,
                    scrollbar: true,
                    change: function (time) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationInjuryDetail.InjuryTime = $('#txt_InjuryTime').val();
                            $scope.$apply();
                        })
                    }
                });
                $('#txt_ReturnedToWorkTime').timepicker({
                    timeFormat: 'HH:mm',
                    interval: 10,
                    dynamic: true,
                    dropdown: true,
                    scrollbar: true,
                    change: function (time) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationInjuryDetail.ReturnedToWorkTime = $('#txt_ReturnedToWorkTime').val();
                            $scope.$apply();
                        })
                    }
                });
                $('#txt_TimeStoppedWork').timepicker({
                    timeFormat: 'HH:mm',
                    interval: 10,
                    dynamic: true,
                    dropdown: true,
                    scrollbar: true,
                    change: function (time) {
                        $timeout(function () {
                            $scope.notification.InjuryNotificationInjuryDetail.TimeStoppedWork = $('#txt_TimeStoppedWork').val();
                            $scope.$apply();
                        })
                    }
                });
            }

            function initComponents() {
                initTooltip();
                initDatePicker();
                initTimePicker();
                $scope.notification = {};
                $scope.notification.InjuryNotificationNotifierDetail = {};
                $scope.notification.InjuryNotificationAttachment = [];
                $scope.notification.InjuryNotificationBankDetail = {};
                $scope.notification.InjuryNotificationEmployeeDetail = {};
                $scope.notification.InjuryNotificationInjuryDetail = {};
                $scope.notification.InjuryNotificationMedicalTreatment = {};


                $scope.notification.InjuryNotificationEmployeeDetail.GenderId = "0";
                $scope.notification.InjuryNotificationEmployeeDetail.IsOtherEmployment = "false"
                $scope.notification.InjuryNotificationEmployeeDetail.IsManagerEmail = "false";
                $scope.notification.InjuryNotificationEmployeeDetail.ContactMethod = "1";

                $scope.notification.InjuryNotificationInjuryDetail.InjuryLocation = "0";
                $scope.notification.InjuryNotificationInjuryDetail.IsWitness = "false";
                $scope.notification.InjuryNotificationInjuryDetail.IsResultOfTransportation = "false";
                $scope.notification.InjuryNotificationInjuryDetail.IsStoppedWork = 'false';
                $scope.notification.InjuryNotificationInjuryDetail.IsThirdPartyInvolved = 'false';
                $scope.notification.InjuryNotificationInjuryDetail.IsInfluenced = 'false';
                $scope.notification.InjuryNotificationInjuryDetail.IsActionAgainst = 'false';

                $scope.notification.InjuryNotificationMedicalTreatment.HasSymtoms = 'false';
                $scope.notification.InjuryNotificationMedicalTreatment.IsSimiliarClaimed = 'false';
                $scope.notification.InjuryNotificationMedicalTreatment.IsOtherMedicalProvider = 'false';
                $scope.notification.InjuryNotificationMedicalTreatment.IsOtherTreatmentInformation = 'false';
            }

            $scope.init = function () {
                if ($filter('dec2bool')(sessionStorage.LoggedIn)) {
                    userService.setUserArray();
                    userService.checkTermConditionAgree();

                    $rootScope.userLogout = function () {
                        userService.logout();
                    };
                }

                //populate employee fields if claimant
                if ($rootScope.user && $rootScope.IsClaimant) {
                    userProfileService.getUserProfile().then(function (response) {
                        var employeeDetail = $scope.notification.InjuryNotificationEmployeeDetail;
                        employeeDetail.EmployeeFirstName = response.FirstName;
                        employeeDetail.EmployeeLastName = response.LastName;
                        employeeDetail.EmployeeHomePhone = response.HomePhone;
                        employeeDetail.EmployeeWorkPhone = response.WorkPhone;
                        employeeDetail.EmployeeMobilePhone = response.MobilePhone;

                        employeeDetail.EmployeeAddressStreet = response.Street;
                        employeeDetail.EmployeeAddressSuburb = response.Suburb;
                        employeeDetail.EmployeeAddressState = response.State;
                        employeeDetail.EmployeeAddressPostCode = response.PostCode;
                        employeeDetail.EmployeePostalAddressStreet = response.PostalStreet;
                        employeeDetail.EmployeePostalAddressSuburb = response.PostalSuburb;
                        employeeDetail.EmployeePostalAddressState = response.PostalState;
                        employeeDetail.EmployeePostalAddressPostCode = response.PostalPostCode;
                        employeeDetail.EmployeeEmailAddress = response.EmailAddress;
                        employeeDetail.EmployeeDateofbirth = $rootScope.user.DateOfBirth;
                        employeeDetail.BankAccountName = response.AccountName;
                        employeeDetail.BSB = response.BankName;
                        employeeDetail.BankAccountNumber = response.AccountNumber;

                        $("#chk_SameAddress").prop('checked', (employeeDetail.EmployeeAddressStreet == employeeDetail.EmployeePostalAddressStreet) &&
                            (employeeDetail.EmployeeAddressSuburb == employeeDetail.EmployeePostalAddressSuburb) &&
                            (employeeDetail.EmployeeAddressState == employeeDetail.EmployeePostalAddressState) &&
                            (employeeDetail.EmployeeAddressPostCode == employeeDetail.EmployeePostalAddressPostCode));
                        $scope.onChangeSameAddress();
                        employeeDetail.EmployeeEmailAddress = $rootScope.user.EmailAddress;
                        $("#txt_EmployeeEmailAddress").prop("disabled", true);

                    });
                }
                initComponents();

                // Wizard Initialization
                $('.wizard-card').bootstrapWizard({
                    'tabClass': 'nav nav-pills',
                    'nextSelector': '.btn-next',
                    'previousSelector': '.btn-previous',
                    onNext: function (tab, navigation, index) {
                        $scope.currentTabIndex = $scope.getCurrentTabIndex();
                        if ($scope.currentTabInvalid()) {
                            popupService.showText($scope.buildErrorContent(), undefined);
                            return false;
                        }
                    },
                    onTabClick: function (tab, navigation, index) {
                        return false;
                    },
                    onTabShow: function (tab, navigation, index) {
                        $scope.currentTabIndex = index;
                        var $total = navigation.find('li').length;
                        var $current = index + 1;

                        var $wizard = navigation.closest('.wizard-card');
                        // If it's the last tab then hide the last button and show the finish instead
                        if ($current >= $total) {
                            $($wizard).find('.btn-next').hide();
                            $($wizard).find('.btn-finish').show();
                        } else {
                            $($wizard).find('.btn-next').show();
                            $($wizard).find('.btn-finish').hide();
                        }

                        if ($scope.currentTabIndex == 4 || $scope.currentTabIndex == 5) {
                            $('#btn_SaveProccess').hide();

                        } else
                            $('#btn_SaveProccess').show();
                    }
                });

                $scope.inputIncidentNumber = location.pathname.substring(location.pathname.indexOf("claim-lodgement/") + "claim-lodgement/".length);
                if ($scope.inputIncidentNumber) {
                    $scope.getFormData(location.pathname.indexOf('review-claim-lodgement') !== -1);
                }
            };
            //end session ini


            //session form functions
            $scope.saveProcess = function (finish) { // if submit , finish = true
                if (finish) {
                    $scope.currentTabIndex = $scope.getCurrentTabIndex();
                    if ($scope.currentTabInvalid()) {
                        popupService.showText($scope.buildErrorContent(), undefined);
                        return false;
                    }
                    if ($scope.FormInvalid()) {
                        popupService.showText(lodgeClaimACTGWording.FORM_INVALID, undefined);
                        return false;
                    }

                }
                if ($scope.InvalidDate()) {
                    popupService.showText(lodgeClaimACTGWording.DATE_INVALID, undefined);
                    return false;
                }
                // need email fields to be able o save
                if (!$scope.notification.InjuryNotificationEmployeeDetail ||
                    !$scope.notification.InjuryNotificationEmployeeDetail.EmployeeEmailAddress) {
                    popupService.showText(lodgeClaimACTGWording.EMAIL_NOT_EXISTED, undefined);
                    return false;
                }

                $scope.onChangeSameAddress();
                if ($scope.fileData && $scope.fileData.scope.queue.length > 0 && finish) {
                    $scope.submitFile(this);
                    $scope.fileData.scope.queue.forEach(function (file) {

                        var attachment = {
                            FileName: file.name,
                            FilePath: $scope.formData.uploadSession + '\\' + file.name,
                            Size: file.size,
                            FileType: file.medicalFileType
                        }
                        $scope.notification.InjuryNotificationAttachment.push(attachment);
                    });
                }

                if ($scope.notification.InjuryNotificationBankDetail.BSB == "null") {
                    $scope.notification.InjuryNotificationBankDetail.BSB = null;
                }
                var params = {};
                params.data = $scope.notification;
                params.finish = finish;
                params.uploadSession = $scope.formData.uploadSession;

                lodgeClaimACTGService.saveLodgeClaimInfo(params).then(function (response) {
                    if (!response.IsSubmitSuccess) {
                        popupService.showError("This incident has already been submited. Please reload this incident number again to check!");
                    } else if (response.Message && response.Message.indexOf("error") !== -1) {
                        popupService.showError("An error occurred. Please check your form again !");
                    } else {
                        $scope.notification.InjuryNotificationId = response.InjuryNotificationId;
                        $scope.notification.IncidentNumber = response.IncidentNumber;
                        $scope.notification.Status = response.Status;
                        $scope.notification.CreatedDate = response.CreatedDate;
                        $scope.notification.CreatedBy = response.CreatedBy;
                        if (finish) {
                            popupService.showText(lodgeClaimACTGWording.LODGE_CLAIM_SUCCESS.replace("{{IncidentNumber}}", $scope.notification.IncidentNumber), undefined);
                            $scope.disableForm();
                        } else
                            popupService.showText(lodgeClaimACTGWording.PROCESS_SAVED.replace("{{IncidentNumber}}", $scope.notification.IncidentNumber), undefined);
                    }
                });
            }

            $scope.disableForm = function () {
                $timeout(function () {
                    $(":input").prop("disabled", true);
                    $(".button-primary").prop('disabled', false);
                    $("#attachment a").removeAttr('href');
                    $("#attachment a").removeAttr('target');
                    $scope.isReadOnly = true;
                })
            }

            $scope.onChangeSameAddress = function () {

                $scope.sameAddress = $("#chk_SameAddress").prop('checked');
                if ($scope.sameAddress) {
                    var employeeDetail = $scope.notification.InjuryNotificationEmployeeDetail;
                    employeeDetail.EmployeePostalAddressStreet = employeeDetail.EmployeeAddressStreet;
                    employeeDetail.EmployeePostalAddressSuburb = employeeDetail.EmployeeAddressSuburb;
                    employeeDetail.EmployeePostalAddressState = employeeDetail.EmployeeAddressState;
                    employeeDetail.EmployeePostalAddressPostCode = employeeDetail.EmployeeAddressPostCode;
                }
            }

            $scope.getFormData = function (disableForm) {

                if ($scope.inputIncidentNumber) {
                    lodgeClaimACTGService.getLodgeClaim($scope.inputIncidentNumber).then(function (response) {
                        if (response) {
                            $scope.notification = response;
                            var notification = $scope.notification;

                            var notifierDetail = notification.InjuryNotificationNotifierDetail;
                            if (notifierDetail) {
                                notifierDetail.NotifierTypeId = notifierDetail.NotifierTypeId ? notifierDetail.NotifierTypeId.toString() : "0";
                            }

                            var employeeDetail = notification.InjuryNotificationEmployeeDetail;
                            if (employeeDetail) {
                                employeeDetail.GenderId = employeeDetail.GenderId ? employeeDetail.GenderId.toString() : "0";

                                employeeDetail.ContactMethod = employeeDetail.ContactMethod ? employeeDetail.ContactMethod.toString() : null;
                                employeeDetail.IsOtherEmployment = employeeDetail.IsOtherEmployment ? "true" : "false";
                                employeeDetail.IsManagerEmail = employeeDetail.IsManagerEmail ? "true" : "false";

                                $scope.sameAddress = (employeeDetail.EmployeeAddressStreet == employeeDetail.EmployeePostalAddressStreet) &&
                                    (employeeDetail.EmployeeAddressSuburb == employeeDetail.EmployeePostalAddressSuburb) &&
                                    (employeeDetail.EmployeeAddressState == employeeDetail.EmployeePostalAddressState) &&
                                    (employeeDetail.EmployeeAddressPostCode == employeeDetail.EmployeePostalAddressPostCode)
                            }
                            var injuryDetail = notification.InjuryNotificationInjuryDetail;
                            if (injuryDetail) {
                                injuryDetail.InjuryLocation = injuryDetail.InjuryLocation ? injuryDetail.InjuryLocation.toString() : "0";

                                injuryDetail.IsStoppedWork = injuryDetail.IsStoppedWork ? "true" : "false";
                                injuryDetail.IsWitness = injuryDetail.IsWitness ? "true" : "false";
                                injuryDetail.IsResultOfTransportation = injuryDetail.IsResultOfTransportation ? "true" : "false";
                                injuryDetail.IsThirdPartyInvolved = injuryDetail.IsThirdPartyInvolved ? "true" : "false";
                                injuryDetail.IsInfluenced = injuryDetail.IsInfluenced ? "true" : "false";
                                injuryDetail.IsActionAgainst = injuryDetail.IsActionAgainst ? "true" : "false";

                                if (injuryDetail.ReturnedToWorkDate)
                                    $('#txt_DateStoppedWork').datepicker('option', 'maxDate', toDate(injuryDetail.ReturnedToWorkDate));
                                if (injuryDetail.DateStoppedWork)
                                    $('#txt_ReturnedToWorkDate').datepicker('option', 'minDate', toDate(injuryDetail.DateStoppedWork));
                                if (injuryDetail.InjuryDate) {
                                    $('#txt_ReportedDate').datepicker('option', 'minDate', toDate(injuryDetail.InjuryDate));
                                    $('#txt_ReturnedToWorkDate').datepicker('option', 'minDate', toDate(injuryDetail.InjuryDate));
                                    $('#txt_DateStoppedWork').datepicker('option', 'minDate', toDate(injuryDetail.InjuryDate));
                                    $('#txt_FirstSeekDate').datepicker('option', 'minDate', toDate(injuryDetail.InjuryDate));
                                    $('#txt_FirstNoticeDate').datepicker('option', 'minDate', toDate(injuryDetail.InjuryDate));
                                }
                            }

                            var medicalTreatment = notification.InjuryNotificationMedicalTreatment;
                            if (medicalTreatment) {
                                medicalTreatment.IsSimiliarClaimed = medicalTreatment.IsSimiliarClaimed ? "true" : "false";
                                medicalTreatment.HasSymtoms = medicalTreatment.HasSymtoms ? "true" : "false";
                                medicalTreatment.IsOtherMedicalProvider = medicalTreatment.IsOtherMedicalProvider ? "true" : "false";
                                medicalTreatment.IsOtherTreatmentInformation = medicalTreatment.IsOtherTreatmentInformation ? "true" : "false";
                            }
                            if (disableForm || response.Status == 1) {
                                if (response.Status == 1) {
                                    popupService.showText(lodgeClaimACTGWording.GET_INCIDENT_NUMBER_FINISHED, undefined);
                                }

                                $scope.disableForm();

                            } else {
                                popupService.showText(lodgeClaimACTGWording.GET_INCIDENT_NUMBER_SUCCESSFULLY, undefined);
                            }
                            var attachments = notification.InjuryNotificationAttachment;
                            if (attachments && attachments.length > 0) {
                                //$scope.formData.uploadSession = attachments[0].FilePath.substring(0, attachments[0].FilePath.indexOf('\\'));
                            }
                            $('#div_Information').css('display', 'none');
                            $('#div_wizard').css('display', 'block');
                            $('#div_save').css('display', 'block');
                        } else {
                            popupService.showText(lodgeClaimACTGWording.INCIDENT_NUMBER_NOT_EXISTED, undefined);
                            return false;
                        }
                    });
                } else {
                    $scope.sameAddress = $scope.sameAddress != null ? $scope.sameAddress : true;
                    $('#div_Information').css('display', 'none');
                    $('#div_wizard').css('display', 'block');
                    $('#div_save').css('display', 'block');
                }
            }

            $scope.onClickOffWorkNo = function () {
                $scope.notification.InjuryNotificationInjuryDetail.DateStoppedWork = null;
                $scope.notification.InjuryNotificationInjuryDetail.TimeStoppedWork = null;
                $scope.notification.InjuryNotificationInjuryDetail.ReturnedToWorkDate = null;
                $scope.notification.InjuryNotificationInjuryDetail.ReturnedToWorkTime = null;
            };

            // format dd/MM/yyyy
            function toDate(dateString) {
                var dateParts = dateString.split("/");
                return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
            }


            //end session form functions

            //session upload
            $scope.aClicked = false;

            function fnFileUploadStop(e) {
                if ($scope.uploadResult.hasError) {
                    var uploadError = $scope.getFileUploadError();
                    popupService.showValidationServerErrors(uploadError, undefined, reload);

                }
            }; // fnFileUploadStop

            function fnFileUploadAdd(e, data) {
                if (data.files.length == 0)
                    return;
                data.files.forEach(function (file, index) {
                    if (!angular.isDefined(file.error)) {
                        if (!$scope.isMedicalFormAttached()) {
                            file.medicalFileType = lodgeClaimACTGWording.MEDICAL_FORM;
                            var uploadDiv = $('#div_UploadMedicalFormArea');
                            uploadDiv.removeClass('upload-error');
                            $("#lbl_MedicalCertificate").remove();
                        } else {
                            file.medicalFileType = lodgeClaimACTGWording.ADDITIONAL_DOCUMENT;
                        }
                    }
                });
                $scope.fileData = data;
                $scope.uploadControl.allowSubmit = data.scope.queue.length > 0;
                $scope.checkAttachmentValidity();
            }; // fnFileUploadAdd

            $scope.selectFiles = function (f, selectMedicalForm) {
                $timeout(function () {
                    if (!$scope.aClicked) {
                        var $file = angular.element(f);
                        if (selectMedicalForm) {
                            if ($scope.isMedicalFormAttached()) {
                                popupService.showText(lodgeClaimACTGWording.VALIDATION_MEDICAL_FORM_EXIST, undefined);
                                return;
                            }
                            $file.removeAttr('multiple')
                            $scope.medicalFileType = lodgeClaimACTGWording.MEDICAL_FORM;
                        } else {
                            $file.attr('multiple', 'multiple');
                            $scope.medicalFileType = lodgeClaimACTGWording.ADDITIONAL_DOCUMENT;
                        }
                        $file.trigger('click');
                    }

                    $scope.aClicked = false;
                    $scope.checkAttachmentValidity();
                }, 0)
            } // selectFiles

            $('body').on('click', '.upload-file', function () {
                $scope.aClicked = true;
            })

            $scope.listAdditionDocument = function () {
                if ($scope.notification.Status === 1) {
                    return $scope.notification.InjuryNotificationAttachment.filter(function (item) {
                        return item.FileType !== lodgeClaimACTGWording.MEDICAL_FORM;
                    })
                } else {
                    if ($scope.fileData == null || $scope.fileData.scope == null || $scope.fileData.scope.queue.length == 0)
                        return null;
                    var files = $scope.fileData.scope.queue;
                    return files.filter(function (item) {
                        return item.medicalFileType !== lodgeClaimACTGWording.MEDICAL_FORM
                    });
                }
            }

            $scope.medicalClaimForm = function () {
                if ($scope.notification.Status === 1) {
                    return $scope.notification.InjuryNotificationAttachment.filter(function (item) {
                        return item.FileType === lodgeClaimACTGWording.MEDICAL_FORM;
                    })
                } else {
                    if ($scope.fileData == null || $scope.fileData.scope == null || $scope.fileData.scope.queue.length == 0)
                        return null;
                    var files = $scope.fileData.scope.queue;
                    return files.filter(function (item) {
                        return item.medicalFileType === lodgeClaimACTGWording.MEDICAL_FORM
                    });
                }
            }

            $scope.isMedicalFormAttached = function () {
                if ($scope.fileData == null || $scope.fileData.scope == null || $scope.fileData.scope.queue.length == 0)
                    return false;
                var files = $scope.fileData.scope.queue;
                var result = files.some(function (file) {
                    var medicalFileType = file.medicalFileType || '';
                    return medicalFileType == lodgeClaimACTGWording.MEDICAL_FORM;
                });
                return result;
            }

            $scope.removeFile = function (file, queue) {
                event.stopPropagation();
                event.preventDefault();
                if (typeof file.$cancel === "function")
                    file.$cancel();
                if (queue.length == 0) {
                    $scope.clearError();
                    $scope.uploadControl.allowSubmit = false;
                }
                $scope.deleteFileUpload(file);
                $scope.checkAttachmentValidity();
            } // removeFile
            $scope.checkAttachmentValidity = function () {
                if ($scope.isMedicalFormAttached()) {
                    $scope.pageForms.ClaimLodgement.attachmentForm.MedicalUpload.$setValidity("Medical_Required", true);
                } else {
                    $scope.pageForms.ClaimLodgement.attachmentForm.MedicalUpload.$setValidity("Medical_Required", false);
                }
            }

            function fnSubmitFile() {
                $scope.uploadResult.hasError = false;
                $scope.uploadControl.isProcessing = true;
                $scope.uploadControl.allowAddFile = false;
                $scope.uploadControl.allowSubmit = false;
                $scope.uploadControl.submitText = 'Uploading...';
            } // fnSubmitFile

            //for finished forms
            $scope.downloadAttachment = function (file) {
                if ($scope.notification.Status !== 1)
                    return false;
                lodgeClaimACTGService.downloadAttachment(file.FilePath, file.FileName);

            }
            //end session upload


            //Session watcher
            $scope.$watch('notification.InjuryNotificationMedicalTreatment.IsOtherMedicalProvider', function (newValue, oldValue) {
                if (newValue == 'false') {
                    $('#txt_OtherMedicalProvider').prop('disabled', true);
                    $('#txt_OtherMedicalProvider').next().hide()
                    $scope.notification.InjuryNotificationMedicalTreatment.OtherMedicalProvider = null;
                    if ($scope.pageForms.ClaimLodgement.medicalForm)
                        $scope.pageForms.ClaimLodgement.medicalForm.OtherMedicalProvider.$setUntouched();
                } else {
                    $('#txt_OtherMedicalProvider').prop('disabled', false);
                    $('#txt_OtherMedicalProvider').next().show()
                }
            });

            $scope.$watch('notification.InjuryNotificationMedicalTreatment.IsOtherTreatmentInformation', function (newValue, oldValue) {
                if (newValue == 'false') {
                    $('#txt_OtherTreatmentInformation').prop('disabled', true);
                    $('#txt_OtherTreatmentInformation').next().hide()
                    $scope.notification.InjuryNotificationMedicalTreatment.OtherTreatmentInformation = null;
                    if ($scope.pageForms.ClaimLodgement.medicalForm)
                        $scope.pageForms.ClaimLodgement.medicalForm.OtherTreatmentInformation.$setUntouched();
                } else {
                    $('#txt_OtherTreatmentInformation').prop('disabled', false);
                    $('#txt_OtherTreatmentInformation').next().show()
                }
            });

            $scope.$watch('notification.InjuryNotificationMedicalTreatment.IsSimiliarClaimed', function (newValue, oldValue) {
                if (newValue == 'false') {
                    $('#txt_ClaimedDetail').prop('disabled', true);
                    $('#txt_ClaimedDetail').next().hide()
                    $scope.notification.InjuryNotificationMedicalTreatment.ClaimedDetail = null;
                    if ($scope.pageForms.ClaimLodgement.medicalForm)
                        $scope.pageForms.ClaimLodgement.medicalForm.ClaimedDetail.$setUntouched();
                } else {
                    $('#txt_ClaimedDetail').prop('disabled', false);
                    $('#txt_ClaimedDetail').next().show()
                }
            });

            $scope.$watch('notification.InjuryNotificationMedicalTreatment.HasSymtoms', function (newValue, oldValue) {
                if (newValue == 'false') {
                    $('#txt_Illness').prop('disabled', true);
                    $('#txt_Illness').next().hide()
                    $scope.notification.InjuryNotificationMedicalTreatment.Illness = null;
                    if ($scope.pageForms.ClaimLodgement.medicalForm)
                        $scope.pageForms.ClaimLodgement.medicalForm.Illness.$setUntouched();
                } else {
                    $('#txt_Illness').prop('disabled', false);
                    $('#txt_Illness').next().show()
                }
            });
            $scope.$watch('sameAddress', function (newValue) {
                $timeout(function () {
                    if (newValue) {
                        $("#div_PostalAddress").hide();
                    } else
                        $("#div_PostalAddress").show();
                })
            }) //end session watcher

            //Session validate
            $scope.currentTabInvalid = function () {
                if ($scope.isReadOnly)
                    return false;
                switch ($scope.currentTabIndex) {
                    case 0:
                        $scope.setTouched($scope.pageForms.ClaimLodgement.employeeForm);
                        return $scope.employeeDetailFormInvalid();
                    case 1:
                        $scope.setTouched($scope.pageForms.ClaimLodgement.injuryForm);
                        return $scope.injuryDetailFormInvalid();
                    case 2:
                        $scope.setTouched($scope.pageForms.ClaimLodgement.medicalForm);
                        return $scope.medicalTreatmentFormInvalid();
                    case 3:
                        $scope.setTouched($scope.pageForms.ClaimLodgement.bankForm);
                        return $scope.bankDetailFormInvalid();
                    case 4:
                        $scope.checkAttachmentValidity();
                        $scope.setTouched($scope.pageForms.ClaimLodgement.attachmentForm);
                        return $scope.attachmentFormInvalid();
                    case 5:
                        $scope.setTouched($scope.pageForms.ClaimLodgement.declarationForm);
                        return $scope.declarationFormInvalid();
                }
            }
            $scope.getCurrentTabIndex = function () {
                return $("li.active").prevAll('li').length;
            }
            $scope.getTabErrorList = function () {
                switch ($scope.currentTabIndex) {
                    case 0:
                        return $scope.pageForms.ClaimLodgement.employeeForm.$error;
                    case 1:
                        return $scope.pageForms.ClaimLodgement.injuryForm.$error;
                    case 2:
                        return $scope.pageForms.ClaimLodgement.medicalForm.$error;
                    case 3:
                        return $scope.pageForms.ClaimLodgement.bankForm.$error;
                    case 4:
                        return $scope.pageForms.ClaimLodgement.attachmentForm.$error;
                    case 5:
                        return $scope.pageForms.ClaimLodgement.declarationForm.$error;
                }
            }
            $scope.getNotRequiredErrorList = function () {
                var list = angular.copy($scope.getTabErrorList());
                if (list && list['required']) {
                    delete list['required'];
                }
                return list;

            }
            $scope.errorMessage = function (key, element) {
                return lodgeClaimACTGWording[element.$name.toUpperCase()] + " " + (lodgeClaimACTGWording[key.toUpperCase()] ? lodgeClaimACTGWording[key.toUpperCase()] : lodgeClaimACTGWording.INVALIDFORMAT);
            }
            $scope.buildErrorContent = function () {
                var content = "<h2 class='error-info'>Information Required</h2><ul class='ul-error'>";
                var errors = $scope.getTabErrorList();
                if (errors['required']) {
                    content += "<li class='error-content'>Highlighted field(s) is mandatory.</li>";
                }
                errors = $scope.getNotRequiredErrorList();
                angular.forEach(errors, function (elements, error) {
                    angular.forEach(elements, function (element, key) {
                        content += "<li class='error-content'>" + $scope.errorMessage(error, element) + '.</li>';
                    })
                })
                content += "</ul>"
                return content;

            }

            $scope.employeeDetailFormInvalid = function () {
                return $scope.pageForms.ClaimLodgement.employeeForm.$invalid;
            }

            $scope.injuryDetailFormInvalid = function () {
                return $scope.pageForms.ClaimLodgement.injuryForm.$invalid;
            }

            $scope.medicalTreatmentFormInvalid = function () {
                return $scope.pageForms.ClaimLodgement.medicalForm.$invalid;
            }

            $scope.bankDetailFormInvalid = function () {
                if ($scope.checkBankDetailFilled()) {
                    return !$scope.notification.InjuryNotificationBankDetail.BankAccountName ||
                        !$scope.notification.InjuryNotificationBankDetail.BSB ||
                        $scope.notification.InjuryNotificationBankDetail.BSB == "null" ||
                        !$scope.notification.InjuryNotificationBankDetail.BankAccountNumber ||
                        $scope.pageForms.ClaimLodgement.bankForm.AuthorityName.$invalid ||
                        !$scope.notification.InjuryNotificationBankDetail.IsPaymentAuthorized
                }
                return false;
            }

            $scope.attachmentFormInvalid = function () {
                return !$scope.isMedicalFormAttached();
            }

            $scope.declarationFormInvalid = function () {
                return $scope.pageForms.ClaimLodgement.declarationForm.$invalid;
            }
            $scope.checkBankDetailFilled = function () {
                return !!$scope.notification.InjuryNotificationBankDetail.BankAccountName ||
                    (!!$scope.notification.InjuryNotificationBankDetail.BSB && $scope.notification.InjuryNotificationBankDetail.BSB != "null") ||
                    !!$scope.notification.InjuryNotificationBankDetail.BankAccountNumber ||
                    !!$scope.notification.InjuryNotificationBankDetail.IsPaymentAuthorized ||
                    !!$scope.notification.InjuryNotificationBankDetail.AuthorityName
            }

            $scope.checkEmployeePhoneFilled = function () {
                return !!$scope.notification.InjuryNotificationEmployeeDetail.EmployeeHomePhone ||
                    !!$scope.notification.InjuryNotificationEmployeeDetail.EmployeeWorkPhone ||
                    !!$scope.notification.InjuryNotificationEmployeeDetail.EmployeeMobilePhone
            }
            $scope.FormInvalid = function () {
                return !!($scope.employeeDetailFormInvalid() || $scope.injuryDetailFormInvalid() || $scope.medicalTreatmentFormInvalid() || $scope.bankDetailFormInvalid() || $scope.attachmentFormInvalid() || $scope.declarationFormInvalid());
            } //End Session validate
            $scope.InvalidDate = function () {
                return !!$scope.pageForms.ClaimLodgement.$error['Invalid_Date'] || !!$scope.pageForms.ClaimLodgement.$error['Invalid_Min_Date'];

            }
            $scope.setTouched = function (form) {
                angular.forEach(form, function (property) {
                    if (property && typeof property.$setTouched === "function") {
                        property.$setTouched();
                    }
                })
            }
        }
    ])